import { Box, Typography, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import osperb from 'assets/img/osperb/osperb25.png';
import { paths } from 'routes/routes/paths';
import useDevice from 'hooks/useDevice';


export default function DefaultFooter() {
  const { isMobile } = useDevice()
  return (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        zIndex: 1,
        background: '#0D0D0D',
        pt: { xs: 6, md: 8 },
        pb: { xs: 4, md: 2 },
      }}
    >
      <Box
        sx={{
          maxWidth: '1280px',
          mx: 'auto',
          px: { xs: 3, md: 6 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'column', md: 'column', lg: "row", xl: 'row' },
            justifyContent: 'space-between',
            gap: 8,
          }}
        >
          {/* Left Column - Logo, Navigation & Services */}
          <Box
            component="img"
            src={osperb}
            alt="Osperb - website development company in india"
            title="Osperb - website development company in india"
            loading="lazy"
            sx={{
              width: { xs: '100px', md: '130px' },
              mb: { xs: 0, md: 5 },
              alignSelf: 'start',
              mt: 0,
              // ml: { xs: -2 }
            }}
          />

          {/* Navigation and Services in two columns */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'row', sm: 'row' },
              gap: { xs: 6, sm: 6, md: 8 },
            }}
          >
            {/* Navigation Links */}
            <Box>
              <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
                {[
                  { label: 'Home', href: '/' },
                  { label: 'Works', href: '/portfolio' },
                  // { label: 'About', href: '/about' },
                ].map((item) => (
                  <Box component="li" key={item.label} sx={{ mb: { xs: 2.5, md: 3 } }}>
                    <Link
                      href={item.href}
                      underline="none"
                      sx={{
                        color: '#E2E2E2DE',
                        fontSize: { xs: '1rem', md: '1rem' },
                        transition: 'color 0.2s',
                        '&:hover': {
                          color: '#fff',
                        },
                      }}
                    >
                      {item.label}
                    </Link>
                  </Box>
                ))}
              </Box>
            </Box>

            {/* Services */}
            <Box>
              <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
                {[
                  { label: 'Steel window factory ERP', href: paths.public.caseStudies.loha },
                  { label: 'Enterprise e-commerce', href: isMobile ? paths.public.eCommerce : '#!' },
                  { label: 'ERP for Pre-owned Cars', href: paths.public.caseStudies.focus },

                  // { label: 'UI/UX Design', href: '/services/ui-ux' },
                ].map((item) => (
                  <Box component="li" key={item.label} sx={{ mb: { xs: 2.5, md: 3 } }}>
                    <Link
                      href={item.href}
                      underline="none"
                      sx={{
                        color: '#E2E2E2DE',
                        fontSize: { xs: '1rem', md: '1rem' },
                        transition: 'color 0.2s',
                        '&:hover': {
                          color: '#fff',
                        },
                      }}
                    >
                      {item.label}
                    </Link>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>



          {/* Horizontal Divider for mobile */}
          <Box
            sx={{
              display: { xs: 'block', md: 'none' },
              borderTop: '1px solid #3D3D3D',
            }}
          />

          {/* Right Column - Contact Info */}
          <Box sx={{ flex: { xs: '1 1 100%', md: '0 0 45%' } }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 2.5, md: 3 } }}>
              {/* Follow us */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 2, md: 3 } }}>
                <Typography
                  sx={{
                    color: '#E2E2E2DE',
                    fontSize: { xs: '1rem', md: '1rem' },
                    minWidth: { xs: '80px', md: '90px' },
                  }}
                >
                  Follow us
                </Typography>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Link
                    href="https://www.instagram.com/osperb_innovations/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    sx={{
                      color: '#E2E2E2DE',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'color 0.2s',
                      '&:hover': {
                        color: '#fff',
                      },
                    }}
                  >
                    <InstagramIcon sx={{ fontSize: '28px' }} />
                  </Link>
                  <Link
                    href="https://www.facebook.com/osperb"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    sx={{
                      color: '#E2E2E2DE',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'color 0.2s',
                      '&:hover': {
                        color: '#fff',
                      },
                    }}
                  >
                    <FacebookIcon sx={{ fontSize: '28px' }} />
                  </Link>
                </Box>
              </Box>

              {/* Call us */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 2, md: 3 } }}>
                <Typography
                  sx={{
                    color: '#E2E2E2DE',
                    fontSize: { xs: '1rem', md: '1rem' },
                    minWidth: { xs: '80px', md: '90px' },
                  }}
                >
                  Call us
                </Typography>
                <Link
                  href="tel:+9109562110055"
                  underline="always"
                  sx={{
                    color: '#E2E2E2DE',
                    fontSize: { xs: '1rem', md: '1rem' },
                    textDecorationColor: '#E2E2E2DE',
                    transition: 'color 0.2s',
                    '&:hover': {
                      color: '#fff',
                      textDecorationColor: '#fff',
                    },
                  }}
                >
                  +91 095621 10055
                </Link>
              </Box>

              {/* Address */}
              <a href='https://g.page/r/Ce0PgulbEBWwEBA?we' target='blank' >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: { xs: 2, md: 3 } }}>
                  <Typography
                    sx={{
                      color: '#E2E2E2DE',
                      fontSize: { xs: '1rem', md: '1rem' },
                      minWidth: { xs: '80px', md: '90px' },
                      flexShrink: 0,
                    }}
                  >
                    Address
                  </Typography>
                  <Box sx={{ color: '#E2E2E2DE', fontSize: { xs: '1rem', md: '1rem' }, lineHeight: 1.6 }}>
                    <Typography sx={{ fontSize: 'inherit', color: 'inherit' }}>
                      3rd floor, Daliya Mall, 966, National Highway,
                    </Typography>
                    <Typography sx={{ fontSize: 'inherit', color: 'inherit' }}>
                      Up Hill, Malappuram, Kerala 676505
                    </Typography>
                    <Typography sx={{ fontSize: 'inherit', color: 'inherit', mt: 0.5 }}>
                      Phone: 095621 10055
                    </Typography>
                  </Box>
                </Box>
              </a>
            </Box>
          </Box>
        </Box>

      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
        <Typography
          sx={{
            fontFamily: 'Satoshi, sans-serif',
            fontWeight: 300,
            fontStyle: 'normal',
            fontSize: '16px',
            lineHeight: '145%',
            letterSpacing: '0%',
            textAlign: 'right',
            color: '#E2E2E2DE',
          }}
        >
          Tech Driven By <Box component="span" sx={{ color: '#1F5BFF' }}>Osperb</Box>
        </Typography>
      </Box>
    </Box>
  );
}
